__turbopack_context__.v({
  "address": "CollectionRow-module__j8Yj7G__address",
  "button": "CollectionRow-module__j8Yj7G__button",
  "card": "CollectionRow-module__j8Yj7G__card",
  "column": "CollectionRow-module__j8Yj7G__column",
  "floorLabel": "CollectionRow-module__j8Yj7G__floorLabel",
  "hideIcon": "CollectionRow-module__j8Yj7G__hideIcon",
  "hideMobile": "CollectionRow-module__j8Yj7G__hideMobile",
  "hideTablet": "CollectionRow-module__j8Yj7G__hideTablet",
  "icon": "CollectionRow-module__j8Yj7G__icon",
  "inscription": "CollectionRow-module__j8Yj7G__inscription",
  "item": "CollectionRow-module__j8Yj7G__item",
  "lastSold": "CollectionRow-module__j8Yj7G__lastSold",
  "lastSoldColumn": "CollectionRow-module__j8Yj7G__lastSoldColumn",
  "link": "CollectionRow-module__j8Yj7G__link",
  "listed": "CollectionRow-module__j8Yj7G__listed",
  "mobileOnly": "CollectionRow-module__j8Yj7G__mobileOnly",
  "owner": "CollectionRow-module__j8Yj7G__owner",
  "percentage": "CollectionRow-module__j8Yj7G__percentage",
  "price": "CollectionRow-module__j8Yj7G__price",
  "priceColumn": "CollectionRow-module__j8Yj7G__priceColumn",
  "row": "CollectionRow-module__j8Yj7G__row",
  "text": "CollectionRow-module__j8Yj7G__text",
});
